import { render } from "./DoctorLoginPage.vue?vue&type=template&id=0be03169&scoped=true&ts=true"
import script from "./DoctorLoginPage.vue?vue&type=script&lang=ts"
export * from "./DoctorLoginPage.vue?vue&type=script&lang=ts"

import "./DoctorLoginPage.vue?vue&type=style&index=0&id=0be03169&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1361425700/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be03169"]])

export default __exports__